export const invoice_details = [
  {
    key:"1",
    Invoice: "INV-1454",
    Image: "user-32.jpg",
    Name: "Anthony Lewis",
    Roll: "anthony@example.com",
    Created_On: "14 Jan 2024, 04:27 AM",
    Total: "$300",
    Amount_Due: "$0",
    Due_Date: "14 Jan 2024, 04:27 AM",
    Status: "Paid",
  },
  {
    key:"2",
    Invoice: "INV-6571",
    Image: "user-09.jpg",
    Name: "Brian Villalobos",
    Roll: "brian@example.com",
    Created_On: "21 Jan 2024, 03:19 AM",
    Total: "$547",
    Amount_Due: "$200",
    Due_Date: "21 Jan 2024, 03:19 AM",
    Status: "Overdue",
  },
  {
    key:"3",
    Invoice: "INV-2245",
    Image: "user-01.jpg",
    Name: "Harvey Smith",
    Roll: "harvey@example.com",
    Created_On: "20 Feb 2024, 12:15 PM",
    Total: "$325",
    Amount_Due: "$65",
    Due_Date: "20 Feb 2024, 12:15 PM",
    Status: "Pending",
  },
  {
    key:"4",
    Invoice: "INV-1456",
    Image: "user-33.jpg",
    Name: "Stephan Peralt",
    Roll: "peral@example.com",
    Created_On: "15 Mar 2024, 12:11 AM",
    Total: "$471",
    Amount_Due: "$145",
    Due_Date: "15 Mar 2024, 12:11 AM",
    Status: "Pending",
  },
  {
    key:"5",
    Invoice: "INV-0045",
    Image: "user-34.jpg",
    Name: "Doglas Martini",
    Roll: "martniwr@example.com",
    Created_On: "12 Apr 2024, 05:48 PM",
    Total: "$147",
    Amount_Due: "$32",
    Due_Date: "12 Apr 2024, 05:48 PM",
    Status: "Overdue",
  },
  {
    key:"6",
    Invoice: "INV-6244",
    Image: "user-02.jpg",
    Name: "Linda Ray",
    Roll: "ray456@example.com",
    Created_On: "20 May 2024, 06:11 PM",
    Total: "$654",
    Amount_Due: "$140",
    Due_Date: "20 May 2024, 06:11 PM",
    Status: "Draft",
  },
  {
    key:"7",
    Invoice: "INV-9565",
    Image: "user-35.jpg",
    Name: "Elliot Murray",
    Roll: "murray@example.com",
    Created_On: "14 Jan 2024, 04:27 AM",
    Total: "$300",
    Amount_Due: "$0",
    Due_Date: "14 Jan 2024, 04:27 AM",
    Status: "Paid",
  },
  {
    key:"8",
    Invoice: "INV-6874",
    Image: "user-36.jpg",
    Name: "Rebecca Smtih",
    Roll: "smtih@example.com",
    Created_On: "02 Sep 2024, 09:21 PM",
    Total: "$654",
    Amount_Due: "$65",
    Due_Date: "02 Sep 2024, 09:21 PM",
    Status: "Paid",
  },
  {
    key:"9",
    Invoice: "INV-1454",
    Image: "user-32.jpg",
    Name: "Anthony Lewis",
    Roll: "anthony@example.com",
    Created_On: "14 Jan 2024, 04:27 AM",
    Total: "$300",
    Amount_Due: "$0",
    Due_Date: "14 Jan 2024, 04:27 AM",
    Status: "Draft",
  },
  {
    key:"10",
    Invoice: "INV-6587",
    Image: "user-37.jpg",
    Name: "Connie Waters",
    Roll: "connie@example.com",
    Created_On: "15 Nov 2024, 12:44 PM",
    Total: "$987",
    Amount_Due: "$47",
    Due_Date: "15 Nov 2024, 12:44 PM",
    Status: "Pending",
  },
  {
    key:"11",
    Invoice: "INV-5879",
    Image: "user-38.jpg",
    Name: "Lori Broaddus",
    Roll: "broaddus@example.com",
    Created_On: "10 Dec 2024, 11:23 PM",
    Total: "$365",
    Amount_Due: "$21",
    Due_Date: "10 Dec 2024, 11:23 PM",
    Status: "Overdue",
  },
];
